import type { ButtonHTMLAttributes } from 'react'

import estilos from './Botao.module.css'

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: 'primario' | 'secundario' | 'sutil' | 'perigo'
  tamanho?: 'normal' | 'pequeno'
  carregando?: boolean
}

export function Botao({
  variante = 'secundario',
  tamanho = 'normal',
  carregando = false,
  disabled,
  children,
  className,
  ...resto
}: Props) {
  return (
    <button
      type="button"
      className={[estilos.botao, estilos[variante], estilos[tamanho], className]
        .filter(Boolean)
        .join(' ')}
      disabled={disabled || carregando}
      // `aria-busy` em vez de trocar o rótulo por "Carregando…": o leitor de
      // tela anuncia o estado sem que o botão mude de largura no meio do clique.
      aria-busy={carregando || undefined}
      {...resto}
    >
      {children}
    </button>
  )
}
